module.exports = __webpack_public_path__ + "static/term-finance-f1eba39e917494c8671c312bb0fa8d3d.jpg";